import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../../Seguranca/Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/rankings/byDepartment'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/rankings/bySectional'
        },
        filterParams
    );

    const rankByCity = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_RANKINGS_CITY,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/rankings/byCity'
        },
        filterParams
    );

    const rankByNeighbourhood = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_RANKINGS_NEIGHBOURHOOD,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/rankings/byNeighborhood'
        },
        filterParams
    );

  

    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byCity: rankByCity.data || [],
        byNeighbourhood: rankByNeighbourhood.data || [],
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
